var map = {
	"./Testimonial.png": 4310,
	"./about.png": 8748,
	"./ali.jpg": 3223,
	"./code.png": 3412,
	"./event-1.png": 7189,
	"./event-2.png": 5390,
	"./event-3.jpg": 7303,
	"./footerlogo.png": 8007,
	"./hLogo.png": 8790,
	"./hero.jpeg": 9340,
	"./hurr.jpg": 9722,
	"./iconfrmae.png": 6957,
	"./id.svg": 7420,
	"./momin.jpg": 7815,
	"./star.png": 6035,
	"./tc.png": 4700,
	"./vm.png": 9316,
	"./yellowstar.png": 6323,
	"./zaigham.jpg": 5596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;